// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 14 ? "bh-helper-instance" : chunkId) + "-legacy." + {"14":"39a150be","107":"958954f8","196":"828da024","266":"666b5ffb","373":"5633bcb8","571":"9fd8e0a1","970":"100dec5b"}[chunkId] + ".js";
};